import React from 'react';
import {
  Box,
  Grid,
  LinearProgress,
  linearProgressClasses,
  Stack,
  styled,
  SxProps,
  Tooltip,
  Typography,
} from '@mui/material';
import moment from 'moment';

import InfoIcon from '@mui/icons-material/Info';

import { useAppSelector } from '../../../../hooks';
import { getCourseStudentsState } from '../../../../store/V2/CourseStudentsSlice';
import { getSubjectColorNew } from '../../../../helper';

const BorderLinearProgress = styled(LinearProgress)(() => ({
  height: 6,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#F1F5F9',
  },
}));

const gridStyles: SxProps = {
  alignItems: 'center',
  borderRadius: '10px',
  minHeight: '62px',
  marginBottom: '10px',
  padding: '16px',
};

const Subscriptions: React.FC = () => {
  // Store
  const courseStudentsState = useAppSelector(getCourseStudentsState);

  const { activeCourses, completedCourses } = courseStudentsState.subscriptions;

  return (
    <Box>
      {activeCourses.length ? (
        <>
          <Typography variant="h6" fontSize="18px">
            Active Subscription
          </Typography>
          <Stack marginTop="24px" marginBottom="14px">
            {activeCourses.map((courseItem, index) => {
              const subjectColor = getSubjectColorNew(
                courseItem.course?.subject || ''
              );

              const classesCompleted = courseItem.classes?.completed || 1;
              const classesTotal = courseItem.classes?.total || 1;
              const progress = parseFloat(
                ((classesCompleted / classesTotal) * 100).toFixed(2)
              );

              const tooltipTitle = `Purchased on : ${moment(
                courseItem.createdAt
              ).format('ddd MMM DD YYYY hh:mm A')}`;

              const classDays =
                courseItem.course && courseItem.course.classDays
                  ? courseItem.course.classDays
                  : [];

              return (
                <Grid
                  key={index}
                  container
                  sx={{
                    ...gridStyles,
                    backgroundColor: `${subjectColor}1A`,
                  }}
                >
                  <Grid item xs={12} sm={12} md={5}>
                    <Typography fontSize="12px" sx={{ color: subjectColor }}>
                      {courseItem.course?.subject} {courseItem.course?.title}
                      {classDays.length ? (
                        <>&nbsp; [{classDays.toString()}]</>
                      ) : null}
                    </Typography>
                  </Grid>
                  <Grid item xs={8} sm={8} md={4}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography fontSize="12px" sx={{ color: '#647488' }}>
                        {classesCompleted} of {classesTotal}&nbsp; Classes
                      </Typography>
                      <Typography fontSize="12px" sx={{ color: '#647488' }}>
                        {progress}%
                      </Typography>
                    </Box>

                    <BorderLinearProgress
                      variant="determinate"
                      value={progress}
                      sx={{
                        '& .MuiLinearProgress-bar': {
                          backgroundColor: subjectColor,
                        },
                      }}
                      style={{
                        marginTop: '6px',
                        backgroundColor: `${subjectColor}26`,
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={3}
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    {/* <Typography
                      fontSize="12px"
                      fontWeight="600"
                      sx={{ color: subjectColor }}
                    >
                      ${courseItem.course?.amount?.toFixed(2)}
                    </Typography> */}
                    <Tooltip title={tooltipTitle} placement="top">
                      <InfoIcon
                        fontSize="small"
                        sx={{
                          color: subjectColor,
                          marginLeft: '11px',
                        }}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>
              );
            })}
          </Stack>
        </>
      ) : null}

      {completedCourses.length ? (
        <>
          <Typography variant="h6" fontSize="18px">
            Completed Subscription
          </Typography>

          <Stack margin="24px 0px">
            {completedCourses.map((courseItem, index) => {
              const subjectColor = '#94A3B8';
              const tooltipTitle = `Purchased on : ${moment(
                courseItem.createdAt
              ).format('ddd MMM DD YYYY hh:mm A')}`;

              const classDays =
                courseItem.course && courseItem.course.classDays
                  ? courseItem.course.classDays
                  : [];

              return (
                <Grid
                  key={index}
                  container
                  sx={{
                    ...gridStyles,
                    backgroundColor: `${subjectColor}1A`,
                  }}
                >
                  <Grid item xs={12} sm={12} md={5}>
                    <Typography fontSize="12px" sx={{ color: subjectColor }}>
                      {courseItem.course?.subject} {courseItem.course?.title}
                      {classDays.length ? (
                        <>&nbsp; [{classDays.toString()}]</>
                      ) : null}
                    </Typography>
                  </Grid>
                  <Grid item xs={10} sm={10} md={6}>
                    <Typography fontSize="12px" sx={{ color: '#647488' }}>
                      Completed on :&nbsp;
                      {moment(courseItem.endDate).format(
                        'ddd MMM DD YYYY hh:mm A'
                      )}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sm={2}
                    md={1}
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    {/* <Typography
                      fontSize="12px"
                      fontWeight="600"
                      sx={{ color: subjectColor }}
                    >
                      ${courseItem.course?.amount?.toFixed(2)}
                    </Typography> */}
                    <Tooltip title={tooltipTitle} placement="top">
                      <InfoIcon
                        fontSize="small"
                        sx={{
                          color: subjectColor,
                          marginLeft: '11px',
                        }}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>
              );
            })}
          </Stack>
        </>
      ) : null}
    </Box>
  );
};

export default Subscriptions;
